import React from 'react';

import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import { ENV } from '@/constants/env';

import { App } from './App';
import './index.css';

if (ENV.SENTRY_ENABLED === '1') {
    Sentry.init({
        dsn: ENV.SENTRY_DSN,
        environment: ENV.SENTRY_ENVIRONMENT,
        integrations: [Sentry.browserTracingIntegration()],

        tracesSampleRate: 1.0,
    });
}

const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);

root.render(<App />);
